import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { danhSachDuDieuKienThucTapApi } from "../../../api/xet-thuc-tap/danhSachDuDieuKienThucTapApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eDanhSachDuDieuKienThucTapActionIds, IDanhSachDuDieuKienThucTapActionTypes } from "../../action-types/xet-thuc-tap/IDanhSachDuDieuKienThucTapActions";
import { rootActions } from "../../actions/rootActions";

export function* danhSachDuDieuKienThucTapSaga(): any {
    yield takeLatest(eDanhSachDuDieuKienThucTapActionIds.LOAD_BY_DOT_THUC_TAP_START, loadByDotXetWorker);
    yield takeLatest(eDanhSachDuDieuKienThucTapActionIds.LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_START, loadByDotChiTietDiemWorker);
    yield takeEvery(eDanhSachDuDieuKienThucTapActionIds.CHUYEN_KHONG_DU_DIEU_KIEN_START, chuyenKhongDuDieuKienWorker);
}

function* chuyenKhongDuDieuKienWorker(action: IDanhSachDuDieuKienThucTapActionTypes): any {
    const payload = action.payload as { id: number, id_dot_thuc_tap: number };
    const response: IBaseResponse = yield call(danhSachDuDieuKienThucTapApi.ChuyenKhongDuDieuKien, payload.id);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.danhSachDuDieuKienThucTap.CHUYEN_KHONG_DU_DIEU_KIEN_SUCCESS(undefined));
        yield put(rootActions.xetThucTap.danhSachDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_START(payload.id_dot_thuc_tap));
        yield put(rootActions.xetThucTap.danhSachKhongDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_START(payload.id_dot_thuc_tap));
    } else {
        yield put(rootActions.xetThucTap.danhSachDuDieuKienThucTap.CHUYEN_KHONG_DU_DIEU_KIEN_ERROR(response.message ?? "Lỗi khi chuyển sinh viên sang không đủ điều kiện"));
    }
}

function* loadByDotXetWorker(action: IDanhSachDuDieuKienThucTapActionTypes) {
    const id_dot_thuc_tap = action.payload as number;
    const response: IBaseResponse = yield danhSachDuDieuKienThucTapApi.SelectByDotThucTap(id_dot_thuc_tap);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.danhSachDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetThucTap.danhSachDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_ERROR(response.message ?? "Lỗi khi tải danh sách không đủ điều kiện thực tập"));
    }
}

function* loadByDotChiTietDiemWorker(action: IDanhSachDuDieuKienThucTapActionTypes) {
    const id_dot_thuc_tap = action.payload as number;
    const response: IBaseResponse = yield danhSachDuDieuKienThucTapApi.SelectByDotThucTapChiTietDiem(id_dot_thuc_tap);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.danhSachDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_SUCCESS({
            danhSachDuDieuKiens: toLowerCaseDeep(response.data.danhSachDuDieuKiens),
            diemXets: toLowerCaseDeep(response.data.diemXets)
        }));
    } else {
        yield put(rootActions.xetThucTap.danhSachDuDieuKienThucTap.LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_ERROR(response.message ?? "Lỗi khi tải chi tiết điểm thực tập"));
    }
}